import axios from 'axios'
import camelize from 'camelize'
import decamelize from 'decamelize-keys-deep'
import moment from 'moment'

import configureStore from '../configureStore'
import User from '../models/user'

const store = configureStore()

const DEFAULT_CONFIG = {
  // this env variables should be in a .env file in the root of the project. DO NOT COMMIT THAT FILE
  baseURL: process.env.REACT_APP_BASE_URL || '/lrs/v1',
  timeout: 50000
}

const decamelizeInterceptor = (config) => {
  const data = config['data']

  if (data) { config.data = decamelize(data) }
  return config
}

const camelizeInterceptor = (response) => {
  const filas = response['data']['filas']

  if (filas) { response.data.filas = camelize(filas) }
  return response
}

const dispatchLogoutOnExpired = () => {
  const tokenInstrospect = JSON.parse(
    window.localStorage.getItem('jwTokenIntrospect'))
  if (!tokenInstrospect) return
  const now = moment().unix()
  if (tokenInstrospect.exp < now) {
    setTimeout(() => {
      store.dispatch({ type: 'USER_LOGGED_OUT_PREVENT' })
      User.logout()
    }, 1000)
  }
}

export const getAxiosInstance = (instanceConfig = {}, includeInterceptors = true) => {
  const token = window.localStorage.getItem('jwToken')
  const options = {
    ...DEFAULT_CONFIG,
    ...instanceConfig
  }
  dispatchLogoutOnExpired()
  if (token) {
    if (!Object.prototype.hasOwnProperty.call(options, 'headers')) {
      options.headers = {}
    }
    options.headers['Authorization'] = `Bearer ${token}`
  }
  const client = axios.create(options)
  if (includeInterceptors) {
    client.interceptors.response.use(camelizeInterceptor)
    client.interceptors.request.use(decamelizeInterceptor)
  }
  return client
}

export default getAxiosInstance
